module.exports = __webpack_public_path__ + "static/p08_cencerro-24ec21269410171d019a78aa1f928634.png";